import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles({
    button: {
        fontSize: '16px',
    },
}, { name: 'CheckNowButton' });
export { useStyles };
